import { LayoutFooter, LayoutSubheader } from '../../_metronic';
import { IBreadcrumb } from '../interfaces/breadcrumb';

interface IProps {
  title?: string;
  breadcrumb?: IBreadcrumb[] | undefined;
  description?: string;
  back?: boolean;
  show?: boolean;
  setModal?: () => void
  setExportFile?: () => void
}

export const setLayoutSubheader = ({
  title = '',
  breadcrumb = [],
  description = '',
  back,
  show = true,
  setModal,
  setExportFile
}: IProps) => {
  LayoutSubheader({ title, breadcrumb, description, back, show, setModal, setExportFile });
};

export const setLayoutFooter = ({
  show = true
}: IProps) => {
  return (LayoutFooter({ show }))
}